import React, { useState } from 'react';
import { addMaterial } from '../../services/materialCalculatorAPI';

const AddMaterial = () => {
  const [name, setName] = useState('');
  const [unit, setUnit] = useState('');
  const [message, setMessage] = useState('');

  const handleSubmit = async (e) => {
    e.preventDefault();
    const res = await addMaterial({ name, unit });
    setMessage(res.message);
    if (res.success) {
      setName('');
      setUnit('');
    }
  };

  return (
    <div className="p-4 max-w-md mx-auto border rounded shadow">
      <h2 className="text-lg font-bold mb-4">➕ Add New Material</h2>
      <form onSubmit={handleSubmit} className="space-y-2">
        <input
          type="text"
          className="w-full border p-2"
          placeholder="Material Name (e.g., Stud, Plywood)"
          value={name}
          onChange={(e) => setName(e.target.value)}
          required
        />
        <input
          type="text"
          className="w-full border p-2"
          placeholder="Unit (e.g., pcs, kg)"
          value={unit}
          onChange={(e) => setUnit(e.target.value)}
          required
        />
        <button type="submit" className="bg-blue-600 text-white px-4 py-2 rounded">
          Add Material
        </button>
        {message && <p className="text-sm text-blue-600 mt-2">{message}</p>}
      </form>
    </div>
  );
};

export default AddMaterial;
